import type {
  ClientFormValues,
  ContactFormValues,
  FormValues,
  SupplierFormValues,
} from './types';

export type FormErrors = Record<keyof FormValues, string | string[]>;

const CLIENT_ERROR_MESSAGES: Record<keyof ClientFormValues, string> = {
  address: '',
  clientTags: 'At least one tag is required',
  listings: '',
  buyerNotifications: '',
};

const SUPPLIER_ERROR_MESSAGES: Record<keyof SupplierFormValues, string> = {
  companyAddress: '',
  companyName: 'Company name is required',
  supplierTags: 'Suppliers must have one tag',
  website: 'Website must be a valid url',
};

const SHARED_ERROR_MESSAGES: Record<keyof ContactFormValues, string> = {
  email: 'Must be a valid email',
  firstName: 'First Name is required',
  lastName: '',
  notes: '',
  phones: 'Valid number is required',
  pronoun: '',
};

const ERROR_MESSAGES: Record<keyof FormValues, string> = {
  ...SHARED_ERROR_MESSAGES,
  ...CLIENT_ERROR_MESSAGES,
  ...SUPPLIER_ERROR_MESSAGES,
};

const DEFAULT_ERRORS: FormErrors = {
  address: '',
  clientTags: '',
  companyAddress: '',
  companyName: '',
  email: '',
  firstName: '',
  lastName: '',
  listings: '',
  notes: '',
  phones: ['', '', ''],
  pronoun: '',
  supplierTags: '',
  website: '',
  buyerNotifications: '',
};

export {
  CLIENT_ERROR_MESSAGES,
  SUPPLIER_ERROR_MESSAGES,
  SHARED_ERROR_MESSAGES,
  DEFAULT_ERRORS,
  ERROR_MESSAGES,
};
